import { Skeleton } from "@mui/material";
import React from "react";
const SkeletonGrid = () => {
  const skeletonGrid = [1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => {
    return (
      <Skeleton
        key={n}
        animation="wave"
        variant="rectangular"
        sx={{
          margin: "8px 15px 8px 15px",
          bgcolor: n % 2 === 0 ? "#e6e6e6" : "#f2f2f2",
          borderRadius: 0.5,
        }}
        width={"calc(100% - 30px)"}
        height={"32px"}
      />
    );
  });
  return (
    <div style={{ width: "100%", height: "90%", overflow: "hidden" }}>
      {skeletonGrid}
    </div>
  );
};
export default SkeletonGrid;
